import { lazy } from '@/service/lazy'
import login from './login'
import esqueciSenha from './esqueci-senha'
import expirado from './expirado'
import logout from './logout'

export default [{
  name: 'Auth',
  path: '/auth',
  redirect: 'auth/login',
  component: lazy('app/auth/index'),
  children: [
    ...login,
    ...esqueciSenha,
    ...expirado,
    ...logout
  ]
}]



// WEBPACK FOOTER //
// ./src/router/modules/auth/index.js